















































































































































































































































































































































































import { Component, Watch, Emit, Vue } from 'vue-property-decorator'
/* component */
import FieldChoiceModal from '@/app/components/Common/FieldChoiceModal.vue'
/* api */
import graphItemApi from '@/app/model/api/graphItemApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { plantingSeason, routerPath, fieldDetailsApiFlag, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    FieldChoiceModal
  }
})
export default class GraphSettingModal extends Vue {
  /* 表示 */
  private isActive:string = '1'
  private showComparisonData : boolean = false
  private showFieldChoice: boolean = false
  private notDataMessage: boolean = false
  private isHeightAcitve: boolean = false
  /* データ */
  private checkboxes: {[key: string]: string|boolean}[] = [
    { label: '積算温度', value: 'integrationTemperature', checked: true, display: true },
    { label: process.env.VUE_APP_ELEMENT1_NAME, value: 'element1', checked: true, display: true },
    { label: process.env.VUE_APP_ELEMENT2_NAME, value: 'element2', checked: true, display: true },
    { label: process.env.VUE_APP_ELEMENT3_NAME, value: 'element3', checked: true, display: true },
    { label: process.env.VUE_APP_ELEMENT4_NAME, value: 'element4', checked: true, display: true }
  ]
  private checkboxes2: {[key: string]: string|boolean}[] = [
    { label: '積算降水量', value: 'soilStatus', checked: false, display: true }
  ]
  private checkboxes4: {[key: string]: string|boolean}[] = [
    { label: '日射量', value: 'solarRadation', checked: false, display: true },
    { label: '積算日射量', value: 'integratedInsolation', checked: false, display: true }
  ]
  private checkboxes5: {[key: string]: string|boolean}[] = [
    { label: '雑草丈', value: 'weedGrowth', checked: false, display: true }
  ]
  private checkboxes3: {[key: string]: string|boolean}[] = [
    { label: '体積含水率', value: 'waterContainRate', checked: true, display: true },
    { label: '地温', value: 'groundTemp', checked: false, display: true }
  ]
  private checkboxes6: {[key: string]: string|boolean}[] = [
    { label: '日平均気温', value: 'temperature', checked: false, display: true },
    { label: '最高気温', value: 'temperatureHighest', checked: false, display: true },
    { label: '最低気温', value: 'temperatureLowest', checked: false, display: true },
    { label: '寒暖差', value: 'temperatureDifference', checked: false, display: true }
  ]
  private masterList:{[key: string]: string|number}[] = []
  private yearList: number[] = []
  private defaultMasterData: any = ''
  private selectedMasterData: any = ''
  private selectedYear: number = 0
  private selectedSeason: string = ''
  private selectedPast: number = 0
  private selectedPastName: string = ''
  private selectedFieldName: string = ''
  private selectedFieldId: string = ''
  private pastData: any[] = []
  private constantValue: any
  /* flag */
  private defaultDataChange: boolean = false

  /* 現在表示されているグラフの年とシーズンを表示 */
  private get defaultDisplayYear () {
    return this.$store.state.graphState.defaultGraphYear
  }
  private get defaultDisplaySeason () {
    return this.$store.state.graphState.defaultGraphSeason
  }
  private get changeGraphCheckbox (): boolean {
    return this.$store.state.graphState.graphCheckbox
  }
  @Watch('changeGraphCheckbox')
  chengeDisplayCheckcox (checkboxs: any) {
    for (let i in this.checkboxes) {
      const data = checkboxs.filter((data: any) => this.checkboxes[i].value === data.value)
      if (data.length !== 0) {
        this.checkboxes[i].checked = data[0].checked
      }
    }
    for (let i in this.checkboxes2) {
      const data = checkboxs.filter((data: any) => this.checkboxes2[i].value === data.value)
      if (data.length !== 0) {
        this.checkboxes2[i].checked = data[0].checked
      }
    }
    for (let i in this.checkboxes3) {
      const data = checkboxs.filter((data: any) => this.checkboxes3[i].value === data.value)
      if (data.length !== 0) {
        this.checkboxes3[i].checked = data[0].checked
      }
    }
    for (let i in this.checkboxes4) {
      const data = checkboxs.filter((data: any) => this.checkboxes4[i].value === data.value)
      if (data.length !== 0) {
        this.checkboxes4[i].checked = data[0].checked
      }
    }
    for (let i in this.checkboxes5) {
      const data = checkboxs.filter((data: any) => this.checkboxes5[i].value === data.value)
      if (data.length !== 0) {
        this.checkboxes5[i].checked = data[0].checked
      }
    }
    for (let i in this.checkboxes6) {
      const data = checkboxs.filter((data: any) => this.checkboxes6[i].value === data.value)
      if (data.length !== 0) {
        this.checkboxes6[i].checked = data[0].checked
      }
    }
  }
  @Watch('defaultDisplayYear')
  setDisplayYear (year: string) {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData === null) {
      this.selectedYear = parseInt(year)
    }
  }
  @Watch('defaultDisplaySeason')
  setDisplaySeason (season: string) {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData === null) {
      this.selectedSeason = season
    }
  }

  created () {
    let fieldId = this.$route.params.field_id
    let plantingId = this.$route.params.planting_id
    let settingData = JSON.parse(Local.getGraphSettingData(fieldId)!)

    /* 表示年度リストを作成 */
    const endYear = new Date().getFullYear() + 1
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = this.constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }
    // グラフ表示項目設定の保持があれば項目に反映
    if (settingData !== null) {
      this.checkboxes = settingData.checkboxs
      this.checkboxes2 = settingData.checkboxs2
      this.checkboxes3 = settingData.checkboxs3
      this.checkboxes4 = settingData.checkboxs4
      this.checkboxes5 = settingData.checkboxs5
      this.checkboxes6 = settingData.checkboxs6
      this.selectedYear = settingData.year
      this.selectedSeason = settingData.season
      this.changeTab(settingData.tab)
      this.selectedFieldName = settingData.fieldName
      this.selectedPast = settingData.past

      if (settingData.tab === '3') {
        this.showFieldChoice = true
        this.$store.commit('fieldChoiceState/setChoosingModalFieldId', settingData.fieldId)
      }

      if (settingData.tab !== '1') {
        this.$store.commit('graphToggleState/setHiddenComparisonData', false)
      }
    }

    this.getGraphItem(fieldId, plantingId)
  }

  /* モーダルデータ取得 */
  private getGraphItem (fieldId: string, plantingId: string) {
    (async () => {
      const result = await graphItemApi.getGraphItem(fieldId)

      if (result.isOk()) {
        this.pastData = result.getPayload().plant_data
        this.$emit('past-data', this.pastData)

        /* 現在のマスタデータ名を取得 */
        let varietyId = JSON.parse(Session.getVarietyId()!)
        for (var j in this.masterList) {
          if (this.masterList[j].id === varietyId) {
            this.selectedMasterData = this.masterList[j]
            this.defaultMasterData = this.masterList[j]
          }
        }

        if (this.pastData.length === 0) {
          this.notDataMessage = true
        } else {
          // flag
          this.$store.commit('setFlagState/setGraphChangeDisplayYear', true)

          /* 現在表示しているグラフの年とシーズンを保持 */
          this.$store.commit('graphState/setDefaultGraphYear', this.pastData[this.pastData.length - 1].year)
          this.$store.commit('graphState/setDefaultGraphSeason', this.pastData[this.pastData.length - 1].season)
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        this.$emit('close-modal')
      }
    })()
  }

  /* 作付けID取得 */
  private getPlantingId (accordionId: number, fieldId: number) {
    if (fieldId !== 0 && fieldId !== undefined) {
      let result: any[] = []

      if (Session.getFieldDetailsData(String(accordionId))! !== null) {
        /* storageから取得 */
        result = JSON.parse(Session.getFieldDetailsData(String(accordionId))!)

        // timestamp削除
        if (result !== null) {
          delete result[0]
        }
        for (var i in result) {
          if (result[i].field_id === fieldId) {
            return result[i].planting_id
          }
        }
      } else {
        /* APIから取得 */
        return this.getDetailsData(accordionId, fieldId)
      }
    }
  }

  /* Storageにデータがない場合APIから取得 */
  private getDetailsData (accordionId: number, fieldId: number) {
    (async () => {
      let searchItem = {
        refile: this.$store.state.fieldState.plantingOnly,
        stage: this.$store.state.fieldState.fieldSearchStatus,
        variety: this.$store.state.fieldState.fieldSearchVariety,
        risk: this.$store.state.fieldState.fieldSearchRisk,
        word: this.$store.state.fieldState.fieldSearchText
      }
      const result = await FieldDetailsApi.getFieldDetailsData(String(accordionId), true, fieldDetailsApiFlag.FLAG_FIELD, searchItem, [])

      if (result.isOk()) {
        let detailsList = result.getPayload().field_detail_list

        // timestamp削除
        if (detailsList !== null) {
          delete detailsList[0]
        }
        for (var i in result) {
          if (detailsList[i].field_id === fieldId) {
            return detailsList[i].planting_id
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* 選択した圃場名を表示 */
  private displaySelectedFiled (val: any) {
    this.selectedFieldName = val
    this.showFieldChoice = true
  }

  /* 選択した圃場ID取得 */
  private getSelectedFiledId (id: any) {
    this.selectedFieldId = id
  }

  /* 項目設定処理 */
  private setGraphItem () {
    let checkList = []
    for (var j in this.checkboxes) {
      if (this.checkboxes[j].checked) {
        checkList.push(this.checkboxes[j])
      }
    }
    for (var k in this.checkboxes2) {
      if (this.checkboxes2[k].checked) {
        checkList.push(this.checkboxes2[k])
      }
    }
    for (var l in this.checkboxes3) {
      if (this.checkboxes3[l].checked) {
        checkList.push(this.checkboxes3[l])
      }
    }
    for (var m in this.checkboxes4) {
      if (this.checkboxes4[m].checked) {
        checkList.push(this.checkboxes4[m])
      }
    }
    for (var n in this.checkboxes5) {
      if (this.checkboxes5[n].checked) {
        checkList.push(this.checkboxes5[n])
      }
    }
    for (var o in this.checkboxes6) {
      if (this.checkboxes6[o].checked) {
        checkList.push(this.checkboxes6[o])
      }
    }

    if (checkList.length === 6 &&
        checkList[0].label === '積算温度' &&
        checkList[1].label === process.env.VUE_APP_ELEMENT1_NAME &&
        checkList[2].label === process.env.VUE_APP_ELEMENT2_NAME &&
        checkList[3].label === process.env.VUE_APP_ELEMENT3_NAME &&
        checkList[4].label === process.env.VUE_APP_ELEMENT4_NAME &&
        checkList[5].label === '体積含水率' &&
        this.selectedYear === this.$store.state.graphState.defaultGraphYear &&
        this.selectedSeason === this.$store.state.graphState.defaultGraphSeason &&
        this.selectedFieldName === '' &&
        this.selectedPast === 0) {
      /* ローカルストレージから削除 */
      localStorage.removeItem('graphSetting' + this.$route.params.field_id)
    } else {
      let plantingId = 0
      for (var i in this.pastData) {
        if (this.pastData[i].season === this.selectedSeason) {
          if (this.pastData[i].year === this.selectedYear) {
            /* 表示年度とシーズン */
            let display = this.selectedYear + '年 ' + this.pastData[i].season
            plantingId = this.pastData[i].planting_id
          }
        }

        /* 過去データ名 */
        if (this.isActive === '2') {
          if (this.pastData[i].planting_id === this.selectedPast) {
            let year = this.pastData[i].year + '年'
            let season = this.pastData[i].season

            this.selectedPastName = year + ' ' + season
          }
        }
      }

      const data = {
        checkboxs: this.checkboxes,
        checkboxs2: this.checkboxes2,
        checkboxs3: this.checkboxes3,
        checkboxs4: this.checkboxes4,
        checkboxs5: this.checkboxes5,
        checkboxs6: this.checkboxes6,
        year: this.selectedYear,
        season: this.selectedSeason,
        plantingId: plantingId,
        fieldId: this.selectedFieldId,
        fieldName: this.selectedFieldName,
        past: this.selectedPast,
        pastName: this.selectedPastName,
        tab: this.isActive
      }
      /* ローカルストレージに保持 */
      Local.setGraphSettingData(JSON.stringify(data), this.$route.params.field_id)
    }

    if (this.defaultDataChange) {
      this.changeDisplayYear(this.selectedYear, this.selectedSeason)
      this.defaultDataChange = false

      if (this.selectedFieldName !== '') {
        this.comparisonField(String(this.$store.state.fieldChoiceState.modalPlantingId))
      }

      if (this.selectedPast !== 0) {
        this.comparisonField(String(this.selectedPast))
      }

      this.$emit('display-graph-item', {
        checkbox: checkList,
        year: this.selectedYear,
        season: this.selectedSeason,
        field: this.selectedFieldName,
        past: this.selectedPastName
      })
    }

    /* 比較データありなし */
    if (this.selectedFieldName === '' && this.selectedPast === 0) {
      // どちらも選択されていない＝比較無
      this.$store.commit('graphToggleState/setHiddenComparisonData', true)
    } else {
      // それ以外＝比較有り
      this.$store.commit('graphToggleState/setHiddenComparisonData', false)
    }

    const checkboxsData = this.checkboxes.concat(this.checkboxes2, this.checkboxes3, this.checkboxes4, this.checkboxes5, this.checkboxes6)

    /* 比較(圃場) */
    if (this.selectedFieldName !== '') {
      this.comparisonField(String(this.$store.state.fieldChoiceState.modalPlantingId))
    } else {
      this.selectedFieldName = ''
      this.$store.commit('graphToggleState/setChangeComparisonGraph', true)
    }

    /* 比較(過去) */
    if (this.selectedPast !== 0) {
      this.comparisonField(String(this.selectedPast))
    } else {
      this.selectedPast = 0
      this.selectedPastName = ''
      this.$store.commit('graphToggleState/setChangeComparisonGraph', true)
    }

    /* 表示項目 */
    this.changeDisplayItem(checkboxsData)
    this.$store.commit('graphToggleState/setCheckboxes', checkList)

    this.$emit('display-graph-item', {
      checkbox: checkList,
      year: this.selectedYear,
      season: this.selectedSeason,
      field: this.selectedFieldName,
      past: this.selectedPastName
    })

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
    this.$emit('tab-reset')
  }

  /* 表示年変更 */
  private changeDisplayYear (year: number, season: string) {
    for (var i in this.pastData) {
      if (this.pastData[i].season === season) {
        if (this.pastData[i].year === year) {
          /* 表示年度とシーズン */
          let display = year + '年 ' + this.pastData[i].season
          this.$store.commit('fieldDetailsState/setDisplayYear', display)

          this.$emit('change-display-year', this.pastData[i].planting_id)
        }
      }
    }

    let pastList = this.pastData.filter(function (data) {
      return (data.season === season && data.year === year)
    })
    // データがなかった場合
    if (pastList.length === 0) {
      this.$emit('show-season-error')

      // 表示を元に戻す
      this.selectedYear = this.$store.state.graphState.defaultGraphYear
      this.selectedSeason = this.$store.state.graphState.defaultGraphSeason
    }

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
  }

  /* 表示項目変更 */
  private changeDisplayItem (list: any) {
    /* 選択されたチェックボックス */
    this.$emit('update-checkboxes', list)
  }

  /* 他の圃場比較 */
  private comparisonField (id: string) {
    this.$emit('add-comparison-data', { id: id, type: 'plant' })
    this.$emit('add-comparison-stage', { id: id, type: 'master' })

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
  }

  /* タブの切り替え */
  private changeTab (num: string) {
    this.isActive = num

    /* 選択中のものをリセット */
    this.selectedFieldName = ''
    this.$store.commit('fieldChoiceState/setChoosingModalFieldId', null)
    this.selectedPast = 0
    this.showFieldChoice = false

    if (num === '3') {
      this.showComparisonData = false
      this.isHeightAcitve = true
    } else {
      this.showComparisonData = true
      this.isHeightAcitve = false
    }
  }

  /* 表示年・シーズンの変更検知 */
  private defaultChange () {
    this.defaultDataChange = true
  }

  /* 表示項目リセット */
  private resetGraphItem () {
    /* チェックボックス */
    this.checkboxes = [
      { label: '積算温度', value: 'integrationTemperature', checked: true, display: true },
      { label: process.env.VUE_APP_ELEMENT1_NAME, value: 'element1', checked: true, display: true },
      { label: process.env.VUE_APP_ELEMENT2_NAME, value: 'element2', checked: true, display: true },
      { label: process.env.VUE_APP_ELEMENT3_NAME, value: 'element3', checked: true, display: true },
      { label: process.env.VUE_APP_ELEMENT4_NAME, value: 'element4', checked: true, display: true }
    ]
    this.checkboxes2 = [
      { label: '積算降水量', value: 'soilStatus', checked: false, display: true }
    ]
    this.checkboxes4 = [
      { label: '日射量', value: 'solarRadation', checked: false, display: true },
      { label: '積算日射量', value: 'integratedInsolation', checked: false, display: true }
    ]
    this.checkboxes5 = [
      { label: '雑草丈', value: 'weedGrowth', checked: false, display: true }
    ]
    this.checkboxes3 = [
      { label: '体積含水率', value: 'waterContainRate', checked: true, display: true },
      { label: '地温', value: 'groundTemp', checked: false, display: true }
    ]
    this.checkboxes6 = [
      { label: '日平均気温', value: 'temperature', checked: false, display: true },
      { label: '最高気温', value: 'temperatureHighest', checked: false, display: true },
      { label: '最低気温', value: 'temperatureLowest', checked: false, display: true },
      { label: '寒暖差', value: 'temperatureDifference', checked: false, display: true }
    ]

    /* 年 */
    this.selectedYear = this.$store.state.graphState.defaultGraphYear

    /* シーズン */
    this.selectedSeason = this.$store.state.graphState.defaultGraphSeason

    this.changeTab('1')

    this.selectedFieldName = ''
    this.showFieldChoice = false
    this.defaultDataChange = true
  }

  private removeSelected () {
    this.selectedFieldName = ''
    this.showFieldChoice = false
  }

  /* モーダルを閉じる */
  private closeModal () {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    // 閉じる前に項目リセット
    // 検索保持があればその状態に戻す
    if (settingData !== null) {
      this.checkboxes = settingData.checkboxs
      this.selectedYear = settingData.year
      this.selectedSeason = settingData.season
      this.selectedFieldName = settingData.field
      this.changeTab(settingData.tab)
      this.selectedPast = settingData.past
    } else {
      this.selectedYear = this.$store.state.graphState.defaultGraphYear
      this.selectedSeason = this.$store.state.graphState.defaultGraphSeason
    }

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
  }
}
